import { useTranslation } from '@packages/utils';
import EditableInput from 'components/Base/EditableFields/EditableInput';
import {
  useShowToastNotification,
  ENotificationType,
} from 'components/Base/Notification';
import { useEditMeetingLinkMutation } from 'redux/apiSlice/events.slice';
import { TRtkErrorType } from 'data/types/generic.types';
import useGetValidationData from 'components/Base/Form/validationRules';
import { Flex } from 'antd';
import { LocationOutline } from 'assets/icon/icon';
import { Text } from 'components/Base/Typography';
import { TMeetingLinkProps } from './MeetingLink.types';

const MeetingLink = ({ eventId, meetingLink }: TMeetingLinkProps) => {
  const { t } = useTranslation({
    keyPrefix:
      'descriptions.admin-portal.events.details.basic-info.meeting-link',
  });
  const { validationRules } = useGetValidationData();
  const { showToastNotification } = useShowToastNotification();
  const [editMeetingLink, { isLoading, isError }] =
    useEditMeetingLinkMutation();
  const onEdit = async (value: string) => {
    try {
      await editMeetingLink({
        id: eventId,
        value,
      }).unwrap();
      showToastNotification({
        message: t('SUCCESS_MESSAGE'),
        type: ENotificationType.SUCCESS,
      });
    } catch (e) {
      showToastNotification({
        message: (e as TRtkErrorType)?.data?.message,
        type: ENotificationType.ERROR,
      });
    }
  };

  return (
    <Flex align="flex-start" data-cy="event-location">
      <Flex align="center" gap={8} style={{ width: 160, marginTop: 8 }}>
        <LocationOutline size={24} />
        <Text color="#808080">{t('LABEL')}</Text>
      </Flex>
      <Flex>
        <EditableInput
          onEdit={onEdit}
          title={meetingLink?.value}
          isError={isError}
          isLoading={isLoading}
          readonly={meetingLink?.allowedOperations.readonly}
          canRemove={meetingLink?.allowedOperations.canRemove}
          emptyText={t('EMPTY_TEXT')}
          rules={[validationRules.validUrl()]}
          validateTrigger="onSubmit"
          backIcon
          fitContent
          wrapperClassName="word-break"
        />
      </Flex>
    </Flex>
  );
};

export default MeetingLink;
